// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3gm6X","rootSuccess":"CompleteLink_rootSuccess__oU44v","rootFailure":"CompleteLink_rootFailure__3C2e1","isDisabled":"CompleteLink_isDisabled__2Tj_J"};